import React from 'react';
import { useEthNetwork } from '@onomy/react-hub';

import { REACT_APP_ETH_NETWORK_NAME } from 'constants/env';
import TransactionFailedModal from './Modals/components/TransactionFailedModal';

export function RequireEthNetwork({ children }: { children: JSX.Element | JSX.Element[] }) {
  const [network] = useEthNetwork();

  if (!network || network.name === REACT_APP_ETH_NETWORK_NAME) return <>{children}</>;

  const displayName =
    REACT_APP_ETH_NETWORK_NAME === 'homestead' ? 'Ethereum Mainnet' : REACT_APP_ETH_NETWORK_NAME;

  return (
    <TransactionFailedModal
      header="Incorrect ETH Network"
      error={`Please set wallet network to ${displayName}`}
      disableClose
    />
  );
}
